'use strict';

const DEVMODE = window.location.host === 'localhost:9360' || window.location.host === 'storebeta.360works.com'; // jshint ignore:line

/**
 * @ngdoc overview
 * @name 360StoreAngularApp
 * @description
 * # 360StoreAngularApp
 *
 * Main module of the application.
 */
angular
	.module('360StoreAngularApp', [
		'ngAnimate',
		'ngCookies',
		'ngMessages',
		'ngRoute',
		'ngTouch',
		'angularMoment',
		'angular-loading-bar',
		'ui.bootstrap',
		'angular-confirm',
	])
	.constant('BASE_URL', DEVMODE && window.location.hostname==='localhost' ? 'http://localhost:9361/' : '/')
	.constant('CARDPOINTE_TOKENIZER_HOST', DEVMODE ? 'https://isv-uat.cardconnect.com' : 'https://fts.cardconnect.com')
	.constant('BUILD_DATE', '{{BUILD_DATE}}')
	/**
	 * How a license can be billed. Mirrors the server's BillingPeriod enum.
	 * `offered: false` is a plan we no longer sell: licenses already on it still say so, but nobody can pick it.
	 */
	.constant('BILLING_PERIODS', [
		{id: 'Monthly', label: 'Monthly', termNoun: 'month', adverb: 'monthly', offered: true, description: 'One twelfth of the annual price, charged every month'},
		{id: 'Quarterly', label: 'Quarterly', termNoun: 'quarter', adverb: 'quarterly', offered: false, description: 'One quarter of the annual price, charged every three months'},
		{id: 'Annual', label: 'Yearly', termNoun: 'year', adverb: 'annually', offered: true, description: 'The full annual price, charged once a year'},
	])
	.config(function ($sceProvider) {
		// Completely disable SCE, allowing ng-bind-html
		$sceProvider.enabled(false);
	})
	.config(function ($httpProvider) {
		// allow $http to send auth header to our server
		$httpProvider.defaults.withCredentials = true;
	})
	.config(function ($locationProvider) {
		// we allow fancy URLs without a hash, thanks to {@link rewrite.config}
		$locationProvider.html5Mode(true);
	})
	.value('$confirmModalDefaults', {
		template: '<div class="modal-header"><h3 class="modal-title">{{data.title}}</h3></div>' +
			'<div class="modal-body">{{data.text}}</div>' +
			'<div class="modal-footer">' +
			'<button class="btn btn-primary" ng-click="ok()">{{data.ok}}</button>' +
			'<button class="btn btn-default" ng-click="cancel()">{{data.cancel}}</button>' +
			'</div>',
		controller: 'ConfirmModalController',
		size: 'sm',
		defaultLabels: {
			title: 'Confirm',
			ok: 'OK',
			cancel: 'Cancel'
		},
		additionalTemplates: {}
	})
	.config(function ($uibModalProvider) {
		$uibModalProvider.options.size = 'lg';
		$uibModalProvider.options.backdrop = 'static';
		$uibModalProvider.options.animation = true;
	})
	.config(function ($routeProvider, BUILD_DATE) {
		// noinspection JSUnusedGlobalSymbols
		$routeProvider
			.when('/', { // landing page, list of products
				templateUrl: 'views/main.html?v=' + BUILD_DATE,
				controller: 'MainCtrl',
				resolve: {
					products: function (api) {
						return api.getProducts();
					}
				}
			})
			.when('/add-product/:code', { // pick a product variant to add for a product line
				reloadOnSearch: false,
				templateUrl: 'views/add-product.html?v=' + BUILD_DATE,
				controller: 'AddProductCtrl',
				resolve: {
					product: function ($route, api) {
						const productCode = $route.current.params.code;
						return api.getProduct(productCode);
					}
				}
			})
			.when('/add-portfolio', { // enter previous licenses to count towards a portfolio purchase
				templateUrl: 'views/add-portfolio.html?v=' + BUILD_DATE,
				controller: 'AddPortfolioCtrl',
				resolve: {
					portfolioVariant: function (api) {
						return api.getProductVariantByProductId(35);
					}
				}
			})
			.when('/add-portfolio-fba', { // easter egg FBA license
				templateUrl: 'views/add-portfolio.html?v=' + BUILD_DATE,
				controller: 'AddPortfolioCtrl',
				resolve: {
					portfolioVariant: function (api) {
						return api.getProductVariant(182); // FBA portfolio product variant
					}
				}
			})
			.when('/mirrorsync', { // configure a MirrorSync order
				templateUrl: 'views/mirrorsync.html?v=' + BUILD_DATE,
				controller: 'MirrorSyncCtrl',
				resolve: {
					support: function (api) {
						return api.mirrorSyncPricing();
					}
				}
			})
			.when('/checkout', { // enter payment
				templateUrl: 'views/checkout.html?v=' + BUILD_DATE,
				controller: 'CheckoutCtrl',
			})
			.when('/receipt', {
				templateUrl: 'views/receipt.html?v=' + BUILD_DATE,
				controller: 'ReceiptCtrl',
				resolve: {
					receiptHtml: function ($route, api) {
						return api.getReceiptHtml($route.current.params.licenseKey, $route.current.params.cartId);
					}
				}
			})
			.when('/login', {
				templateUrl: 'views/login.html?v=' + BUILD_DATE,
				controller: 'LoginCtrl',
			})
			.when('/login-customer', {
				templateUrl: 'views/login-customer.html?v=' + BUILD_DATE,
				controller: 'LoginCustomerCtrl',
			})
			.when('/logout', {
				templateUrl: 'views/logout.html?v=' + BUILD_DATE,
				controller: 'LogoutCtrl',
			})
			.when('/verify-login', {
				templateUrl: 'views/verify-login.html?v=' + BUILD_DATE,
				controller: 'VerifyLoginCtrl'
			})
			.when('/reset-password', {
				templateUrl: 'views/reset-password.html?v=' + BUILD_DATE,
				controller: 'ResetPasswordCtrl',
			})
			.when('/licenses', { // FIX! redirect to my-licenses, delete LicensesCtrl
				redirectTo: function (params, path, search) {
					if (search.licenseKey || search.registeredTo) {
						return '/licenses-legacy?licenseKey=' + (search.licenseKey || '') + '&registeredTo=' + (search.registeredTo || '');
					}
					return '/my-licenses';
				}
			})
			.when('/licenses-legacy', { // FIX! redirect to my-licenses, delete LicensesCtrl
				templateUrl: 'views/licenses.html?v=' + BUILD_DATE,
				controller: 'LicensesCtrl',
			})
			.when('/renew', {
				redirectTo: function (params, path, search) {
					return '/licenses?licenseKey=' + (search.licenseKey || '') + '&registeredTo=' + (search.registeredTo || '');
					// return '/licenses?licenseKey=' + (search.licenseKey || '') + '&registeredTo=' + (search.registeredTo || '');
				}
			})
			.when('/admin', {
				templateUrl: 'views/admin.html?v=' + BUILD_DATE,
				controller: 'AdminCtrl',
				reloadOnSearch: false,
				resolve: {
					user: function (api) {
						return api.adminCurrentUser();
					}
				}
			})
			.when('/reports', {
				templateUrl: 'views/reports.html?v=' + BUILD_DATE,
				controller: 'ReportsCtrl',
				resolve: {
					user: function (api) {
						return api.adminCurrentUser();
					}
				}
			})
			.when('/reports/dynamic-report', {
				templateUrl: 'views/reports/dynamic-report.html?v=' + BUILD_DATE,
				controller: 'ReportsDynamicReportCtrl',
				reloadOnSearch: false,
			})
			.when('/update-payment-info', { // legacy URL format with named `licenseKey` parameter
				templateUrl: 'views/update-payment-info.html?v=' + BUILD_DATE,
				controller: 'UpdatePaymentInfoCtrl',
				resolve: {
					paymentInfoPayload: ($location, $route, api) => {
						const licenseKey = $route.current.params.licenseKey;
						if (!licenseKey) {
							$location.path('/my-licenses');
							return Promise.reject('No license key specified');
						}
						return api.get('api/update-payment-info?licenseKey=' + licenseKey);
					}
				}
			})
			.when('/update-payment-info/:license', {
				templateUrl: 'views/update-payment-info.html?v=' + BUILD_DATE,
				controller: 'UpdatePaymentInfoCtrl',
				resolve: {
					paymentInfoPayload: ($route, api) => {
						const licenseKey = $route.current.params.license;
						return api.get('api/update-payment-info?licenseKey=' + licenseKey);
					}
				}
			})
			.when('/admin/license-tool', {
				reloadOnSearch: false,
				templateUrl: 'views/admin-license-tool.html?v=' + BUILD_DATE,
				controller: 'AdminLicenseToolCtrl',
			})
			.when('/unsubscribe', {
				templateUrl: 'views/unsubscribe.html?v=' + BUILD_DATE,
				controller: 'UnsubscribeCtrl',
			})
			.when('/my-licenses', {
				templateUrl: 'views/my-licenses.html?version=' + BUILD_DATE,
				controller: 'MyLicensesCtrl',
				resolve: {
					user: function (session) {
						return session.getOrFetchCurrentUser();
					},
					licenses: function (api) {
						return api.getMyLicenses(); // calls "api/my-licenses"
					},
				}
			})
			.when('/register', {
				templateUrl: 'views/register.html?version=' + BUILD_DATE,
				controller: 'RegisterCtrl',
			})
			.when('/verify-email', {
				templateUrl: 'views/verify-email.html?v=' + BUILD_DATE,
				controller: 'VerifyEmailCtrl',
			})
			.when('/reports/sales-versus-time', { // FIX! not implemented yet, because jobTracker database is on a separate MySQL instance than 360Store, so we cannot query it easily.
				templateUrl: 'views/reports-sales-versus-time.html?v=' + BUILD_DATE,
				controller: 'ReportsSalesVersusTimeCtrl',
			})
			.otherwise({
				redirectTo: '/'
			});
	})
	.config(function () {
		window.toastr.options.timeOut = 15000;
		window.toastr.options.extendedTimeOut = 15000;
	})
	// .run(function (Analytics) {
	// 	console.log('Init analytics' || Analytics); // just need to refer to an instance
	// })
	.run(function ($rootScope, $location, Analytics, BASE_URL) {
		$rootScope.$on('$routeChangeSuccess', function () {
			// ga('send', 'pageview', $location.path());
			Analytics.track_page_view();
		});
		$rootScope.BASE_URL = BASE_URL;
	})
	.run(function ($rootScope, BUILD_DATE) {
		$rootScope.buildDate = BUILD_DATE;
		$rootScope.year = new Date().getFullYear();
	})
	.run(function (api, $rootScope) { // fetch global settings which live on the server, e.g. valueLists which maybe should be database-driven instead of hard-coded
		api.getServerInfo().then(function (serverInfo) {
			serverInfo.devmode = DEVMODE;
			$rootScope.serverInfo = serverInfo;
		});
	});

